import React from "react";

// reactstrap components
import {
    Button,
    Col,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Modal, ModalBody, ModalFooter,
    ModalHeader,
    Row
} from "reactstrap";

import {apiRequest, apiRoot} from 'lib/Api';
import {getAuthToken, getUserData} from 'lib/Auth';
import * as queryString from "query-string";
import * as moment from "moment";
import defaultAvatar from "assets/img/default-avatar.png";
import PerfectScrollbar from "perfect-scrollbar";
import {JitsiMeeting} from "@jitsi/react-sdk";
import { withUserAgent } from "react-useragent";
import {Link} from "react-router-dom";

const PING_INTERVAL = 30000;  // 1 min

// for testing
const testMode = false;
let myUsername = null;

let lastMessage = '';
class Chat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            direct: '',
            username: '',
            message: '',
            messages: [],
            intervalId: null,
            isGuest: false,
            token: '',
            chatId: '',
            lastTime: '',
            lastId: '',
            currentUser: getUserData(),
            chatSessionId: null,
            showHelpModal: false,
            cameraPermission: null,   // 'granted' | 'denied' | 'prompt' | null
            micPermission: null       // 'granted' | 'denied' | 'prompt' | null
        };
        this._permissionHandles = { camera: null, microphone: null };
    }

    componentWillUnmount() {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
        // limpar listeners de permissions API, se existirem
        try {
            if (this._permissionHandles.camera) this._permissionHandles.camera.onchange = null;
            if (this._permissionHandles.microphone) this._permissionHandles.microphone.onchange = null;
        } catch(e) {}
    }


    get id() {
        if (this.props.match.params) {
            return this.props.match.params.id;
        }
        return null;
    }

    get chatId() {
        return this.state.chatId
    }

    async componentDidMount() {
        if (!this.id) {
            return;
        }

        let intervalId = setInterval(this.getMessages, 2000);
        this.setState({intervalId: intervalId});

        let token = queryString.parse(this.props.location.search).token;
        this.setState({token: token});
        await this.fetchChatInfo();

        window.addEventListener("unload", e => {

            // when page's unload, use sendBeacon to make sure that
            // a request will be send to backend
            const url = apiRoot + `/chat-sessions/close?token=` + getAuthToken() + `&chat_id=${this.chatId}`;
            const success = navigator.sendBeacon(url);
        })
    }

    handleChange = (name, value) => {
        if (typeof name == 'object' && typeof name.target == 'object') {
            let event = name;
            event.preventDefault();
            name = event.target.name;
            value = event.target.value;
        }
        this.setState({[name]: value});
    }



    /**
     * Fetch info required to open chat in rocket.chat
     */
    async fetchChatInfo() {

        let token = queryString.parse(this.props.location.search).token;
        if (token) {
            await apiRequest("/auth/guest?token=" + token, {method: "GET"}).then(response => {
                this.setState({isGuest: true})
                return;
            });
        } else {
            //return;
            return await apiRequest("/appointments/" + this.id + "/chat", {method: "POST"})
                .then(async response => {
                    this.setState({
                        direct: response.data.direct,
                        username: response.data.username
                    });
                    if (testMode) {
                        myUsername = response.data.username;
                    }
                    await this.openChatSession(this.id);
                    //await this.getMessages();
                });
        }
    }

    openChatSession = (roomId) => {
        if (this.state.isGuest) {
            return;
        }
        let params = {appointment_id: roomId, current_user: this.state.direct};
        return apiRequest('/chat-sessions/open', {method: "POST", data: params})
            .then(response => {
                let {data} = response.data;
                this.setState({chatId: data.id, chatSessionId: data.chat_id});
                setInterval(this.ping, PING_INTERVAL);
            });
    }

    maybeNotifyMessage = (message) => {
        let data = {message, chat_id: this.state.chatId};
        return apiRequest(`/chat-sessions/new-message`, {method: "POST", data});
    }

    ping = () => {
        if (this.state.isGuest) {
            return;
        }
        let data = {chat_id: this.state.chatId};
        return apiRequest(`/chat-sessions/ping`, {method: "POST", data});
    }

    send = async () => {
        let message = this.state.message
        if (this.state.message === '' || lastMessage === message) {
            return;
        }

        let data = {
            message: message,
            chat_id: this.state.chatId,
        }
        lastMessage = message;
        this.setState({message: ''});
        await apiRequest(`/chat/messages`, {method: "POST", data});
    }

    getMessages = async () => {
        if (this.state.isGuest) {
            return;
        }

        let data = {
            chat_id: this.state.chatSessionId,
            last_check: this.state.lastTime
        }
        await apiRequest(`/chat/messages`, {method: "GET", data}).then((response) => {
            let messagesState = this.state.messages;
            const messages = response.data.data
            let lastId = ''

            if (messages.length > 0) {
                messagesState = messagesState.concat(messages)
                const lastMessage = messages[messages.length - 1];
                lastId = 'msg' + lastMessage.uuid;
                let lastTime = lastMessage.created_at;
                this.setState({messages: messagesState, lastTime: lastTime});
            }
            this.setState({lastId: lastId});
        });
    }

    renderMessages = () => {
        let messages = this.state.messages;
        return (
            messages.map((message, i) => {
                let className = "msg right-msg";
                if (message.user_id === this.state.currentUser.id) {
                    className = "msg left-msg";
                }

                let lastId = 'msg' + message.uuid;
                let hour = moment(message.created_at).format('DD/MM/YYYY - HH:mm')
                let avatar = message.picture_url || defaultAvatar;
                return (
                    <div className={className} key={message.uuid} id={lastId}>
                        <div
                            className="msg-img"
                        >
                            <img className={"image"} src={avatar}/>
                        </div>

                        <div className="msg-bubble">
                            <div className="msg-info">
                                <div className="msg-info-name">{message.name}</div>
                                <div className="msg-info-time">{hour}</div>
                            </div>

                            <div className="msg-text">
                                {message.message}
                            </div>
                        </div>
                    </div>
                )
            })
        )
    }

    componentWillUnmount() {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
        // limpar listeners de permissions API, se existirem
        try {
            if (this._permissionHandles.camera) this._permissionHandles.camera.onchange = null;
            if (this._permissionHandles.microphone) this._permissionHandles.microphone.onchange = null;
        } catch(e) {}
    }


    toggleHelpModal = (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        this.setState(
          (prev) => ({ showHelpModal: !prev.showHelpModal }),
          async () => {
              if (this.state.showHelpModal) {
                  await this.initPermissionsMonitor();
              }
          }
        );
    }

    async initPermissionsMonitor() {
        // Tenta Permissions API primeiro
        const hasPermissionsApi = typeof navigator !== 'undefined' && navigator.permissions && navigator.permissions.query;
        if (hasPermissionsApi) {
            // Camera
            try {
                const cam = await navigator.permissions.query({ name: 'camera' });
                this._permissionHandles.camera = cam;
                this.setState({ cameraPermission: cam.state });
                cam.onchange = () => this.setState({ cameraPermission: cam.state });
            } catch (e) {
                // Fallback via getUserMedia
                await this.probeViaGUM('video');
            }
            // Microfone
            try {
                const mic = await navigator.permissions.query({ name: 'microphone' });
                this._permissionHandles.microphone = mic;
                this.setState({ micPermission: mic.state });
                mic.onchange = () => this.setState({ micPermission: mic.state });
            } catch (e) {
                await this.probeViaGUM('audio');
            }
        } else {
            // Fallback geral
            await Promise.all([this.probeViaGUM('video'), this.probeViaGUM('audio')]);
        }
    }

    async probeViaGUM(kind) {
        // kind: 'video' | 'audio'
        const constraints = kind === 'video' ? { video: true, audio: false } : { video: false, audio: true };
        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                // Sem suporte: marque como 'prompt' (desconhecido) para não sinalizar erro falso
                if (kind === 'video') {
                    const camState = (this.state.cameraPermission !== null && this.state.cameraPermission !== undefined)
                      ? this.state.cameraPermission
                      : 'prompt';
                    this.setState({ cameraPermission: camState });
                }
                if (kind === 'audio') {
                    const micState = (this.state.micPermission !== null && this.state.micPermission !== undefined)
                      ? this.state.micPermission
                      : 'prompt';
                    this.setState({ micPermission: micState });
                }
                return;
            }
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            // Se chegou aqui, permissão concedida para esse tipo
            if (kind === 'video') this.setState({ cameraPermission: 'granted' });
            if (kind === 'audio') this.setState({ micPermission: 'granted' });
            // Encerrar tracks imediatamente
            stream.getTracks().forEach(t => t.stop());
        } catch (err) {
            // Usuário negou ou dispositivo indisponível
            const denied = err && (err.name === 'NotAllowedError' || err.name === 'SecurityError');
            const state = denied ? 'denied' : (err && err.name === 'NotFoundError' ? 'denied' : 'prompt');
            if (kind === 'video') this.setState({ cameraPermission: state });
            if (kind === 'audio') this.setState({ micPermission: state });
        }
    }


    renderPermissionBadge(label, state) {
        const color =
          state === 'granted' ? '#28a745' : // verde
            state === 'denied' ? '#dc3545' :  // vermelho
              '#6c757d';                        // cinza (desconhecido/prompt)
        const title =
          state === 'granted' ? `${label}: permitido` :
            state === 'denied' ? `${label}: bloqueado` :
              `${label}: solicitar permissão`;
        return (
          <div style={{ display: 'flex', alignItems: 'center', marginRight: 16 }} title={title}>
                <span
                  aria-label={title}
                  style={{
                      width: 15,
                      height: 15,
                      borderRadius: '50%',
                      backgroundColor: color,
                      display: 'inline-block',
                      marginRight: 8
                  }}
                />
              <strong style={{ fontSize: 14 }}>{label}</strong>
          </div>
        );
    }


    renderHelpModal = () => {
        return (
          <Modal size={'lg'} isOpen={this.state.showHelpModal} toggle={this.toggleHelpModal}>
              <ModalHeader>
                  Ajuda com Vídeo e Microfone
              </ModalHeader>
              <ModalBody>
                  <div className={'text-center'} style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                      {this.renderPermissionBadge('Câmera', this.state.cameraPermission)}
                      {this.renderPermissionBadge('Microfone', this.state.micPermission)}
                  </div>

                  - Verifique se a câmera e o microfone estão permitidos no navegador.<br />
                  - Feche outros apps que estejam usando a câmera ou o microfone. <br />
                  - Atualize a página ou tente usar o Chrome/Firefox atualizados. <br />
                  - Pressione CTRL SHIFT R para recarregar a página.<br />

                  <br />
                  - Se o navegador não solicitou o acesso conforme a imagem abaixo, verifique como dar permissão manualmente na próxima imagem.
                  <img src='/img/imagem-chat-01.png' style={{width: '100%'}} alt='imagem-chat-01' />

                  <br /><br />
                  - Ao lado da URL, clique no ícone de cadeado para abrir a janela conforme print abaixo e verifique se as permissões estão corretas. Devem estar exatamente como a imagem. Permitir para microfone e vídeo.
                  <img src='/img/imagem-chat-02.png' style={{width: '100%'}} alt='imagem-chat-02' />
                  <br /><br />
                  - Se não aparecer as opções, o navegador bloqueou, nesse caso verifique a imagem abaixo. Repita o processo dessa imagem para Câmera e Microfone.
                  <img src='/img/imagem-chat-03.png' style={{width: '100%'}} alt='imagem-chat-03' />
              </ModalBody>
              <ModalFooter>
                  <Button color="secondary" onClick={this.toggleHelpModal}>
                      Fechar
                  </Button>
              </ModalFooter>
          </Modal>
        );
    }



    render() {
        if (!this.state.direct && false) {
            return <p></p>;
        }


        if (this.state.isGuest) {
            return (
                <>
                    <div className="content">
                        <Row>
                            <Col md="3">
                                <Row>
                                    <div style={{height: '80vh'}}>
                                    </div>
                                </Row>
                            </Col>
                            {this.renderJitsiWeb()}
                            <Col md="3">
                                <Row>
                                    <div style={{height: '80vh'}}>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </>
            );
        } else {

            if (this.props.ua.mobile === null) {
                return (
                    <>
                        {this.renderHelpModal()}

                        <div className="text-center" style={{marginBottom: '10px'}} >
                            <Link to={'#'} onClick={this.toggleHelpModal} style={{color: '#FFF'}}>
                                Precisa de ajuda com o vídeo/microfone?
                            </Link>
                        </div>

                        <div className="content">
                            <Row>
                                <Col md="5">
                                    <Row>
                                        <div className="chatbox" style={{height: '80vh'}}>
                                            <div className="msger-chat">
                                                {this.renderMessages()}
                                            </div>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="msger-inputarea">
                                            <FormGroup>
                                                <InputGroup>
                                                    <Input type='text' name='message' className='msger-input'
                                                           onKeyPress={event => {
                                                               if (event.which === 13) {
                                                                   event.preventDefault();
                                                                   this.send(event);
                                                               }
                                                           }
                                                           }
                                                           onChange={this.handleChange} value={this.state.message}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText onClick={this.send}
                                                                        className={'msger-send-btn'}>
                                                            &nbsp;<i className="fa fa-paper-plane"/>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </FormGroup>
                                        </div>
                                    </Row>
                                </Col>
                                {this.renderJitsiWeb()}
                            </Row>
                        </div>
                    </>
                )
            } else {
                return (
                    <>
                        <Row>
                            <Col md="5">
                                <Row>
                                    <div className="chatbox" style={{height: '40vh'}}>
                                        <div className="msger-chat">
                                            {this.renderMessages()}
                                        </div>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="msger-inputarea">
                                        <FormGroup>
                                            <InputGroup>
                                                <Input type='text' name='message' className='msger-input'
                                                       onKeyPress={event => {
                                                           if (event.which === 13) {
                                                               event.preventDefault();
                                                               this.send(event);
                                                           }
                                                       }
                                                       }
                                                       onChange={this.handleChange} value={this.state.message}
                                                />
                                                <InputGroupAddon addonType="append">
                                                    <InputGroupText onClick={this.send}
                                                                    className={'msger-send-btn'}>
                                                        &nbsp;<i className="fa fa-paper-plane"/>
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        </FormGroup>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                        {this.renderJitsiMobile()}
                    </>
                )
            }
        }
    }

    renderJitsiWeb() {

        if (this.props.ua.mobile === null) {
            return <>
                <Col md="6" id='video-container-users'>
                    {this.renderJitsi()}
                </Col>
            </>
        }
    }

    renderJitsiMobile() {
        if (this.props.ua.mobile !== null) {
            return <>
                <Row style={{marginTop: '50px', height: '770px'}}>
                    <Col>
                        {this.renderJitsi()}
                    </Col>
                </Row>
            </>
        }
    }

    renderJitsi() {

        let height = '98%';
        if (this.props.ua.mobile !== null) {
            height = '750px';
        }

        let name = '';
        if (this.state.currentUser && this.state.currentUser.name) {
            name = this.state.currentUser.name;
        }
        return <>
            <JitsiMeeting
                domain={"meet.selfguru.com.br"}
                roomName={`Encontro_${this.id}`}

                configOverwrite = {{
                    disableThirdPartyRequests: false,
                    disableLocalVideoFlip: true,
                    disableChat:true,
                    disablePolls: true,
                    lang:'pt',
                }}
                interfaceConfigOverwrite = {{
                    MOBILE_APP_PROMO: false,
                    TILE_VIEW_MAX_COLUMNS: 4,
                }}
                userInfo = {{
                    displayName: name
                }}
                getIFrameRef = { (iframeRef) => { iframeRef.style.height = height; } }
            />
        </>
    }
}

export default withUserAgent(Chat);
